import { MS_PER_SECOND } from '@/utils';
import { OtpRateLimitStateReasonEnum } from '@bvengineering/cas-member-gateway-service-client';
import type { OtpRateLimitState } from '@bvengineering/cas-member-gateway-service-client';

/** Normalize initiate/verify errors once on receipt; other 429 reasons are not lockouts. */
export function getBlockedDeadline(
  status: number,
  body: OtpRateLimitState,
  receivedAt = Date.now()
): number | undefined {
  if (status !== 429 || body?.reason !== OtpRateLimitStateReasonEnum.Blocked) {
    return undefined;
  }

  if (
    typeof body.retryAfterSeconds !== 'number' ||
    !Number.isFinite(body.retryAfterSeconds) ||
    body.retryAfterSeconds < 0 ||
    !Number.isFinite(receivedAt)
  ) {
    throw new RangeError('BLOCKED response requires a non-negative finite retryAfterSeconds');
  }

  const deadline = receivedAt + body.retryAfterSeconds * MS_PER_SECOND;
  if (!Number.isFinite(deadline))
    throw new RangeError('BLOCKED deadline is outside the supported range');
  return deadline;
}
